/* QISSAAT · Scrapbook — interactive bloom builder + helpers */
(function () {
  var svgNS = 'http://www.w3.org/2000/svg';
  var PETAL_SETS = [
    ['#e0779a', '#c4527a', '#f2a6c2'],
    ['#d4527a', '#b03a60', '#e890ae'],
    ['#c9436d', '#a52c54', '#e07a9e'],
    ['#e690b0', '#c15c84', '#f5b8d0']
  ];
  var GID = 0;

  function rand(a, b) { return a + Math.random() * (b - a); }
  function uid() { GID += 1; return 'qsg' + GID + '_' + Math.floor(Math.random() * 1e6); }

  function buildCluster(el) {
    var w = el.clientWidth || parseInt(el.style.width, 10) || 260;
    var h = el.clientHeight || parseInt(el.style.height, 10) || 220;
    var corner = el.dataset.corner || 'tr';

    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.style.width = '100%';
    svg.style.height = '100%';
    svg.style.overflow = 'visible';

    var defs = document.createElementNS(svgNS, 'defs');
    svg.appendChild(defs);

    var sx, sy, ex, ey;
    if (corner === 'tr') { sx = w + 6; sy = -6; ex = w * 0.22; ey = h * 0.9; }
    else if (corner === 'tl') { sx = -6; sy = -6; ex = w * 0.78; ey = h * 0.9; }
    else if (corner === 'br') { sx = w + 6; sy = h + 6; ex = w * 0.22; ey = h * 0.1; }
    else { sx = -6; sy = h + 6; ex = w * 0.78; ey = h * 0.1; }
    var mx = (sx + ex) / 2 + rand(-w * 0.12, w * 0.12);
    var my = (sy + ey) / 2 + rand(-h * 0.12, h * 0.12);

    var vine = document.createElementNS(svgNS, 'path');
    vine.setAttribute('d', 'M' + sx + ' ' + sy + ' Q ' + mx + ' ' + my + ' ' + ex + ' ' + ey);
    vine.setAttribute('class', 'qs-vine-path');
    vine.setAttribute('fill', 'none');
    svg.appendChild(vine);

    var pathLen = vine.getTotalLength();
    var flowerGroup = document.createElementNS(svgNS, 'g');
    svg.appendChild(flowerGroup);

    var leafGradId = uid();
    var leafGrad = document.createElementNS(svgNS, 'linearGradient');
    leafGrad.setAttribute('id', leafGradId);
    leafGrad.setAttribute('x1', '0%'); leafGrad.setAttribute('x2', '100%');
    var lg1 = document.createElementNS(svgNS, 'stop'); lg1.setAttribute('offset', '0%'); lg1.setAttribute('stop-color', '#7c9560');
    var lg2 = document.createElementNS(svgNS, 'stop'); lg2.setAttribute('offset', '100%'); lg2.setAttribute('stop-color', '#a3b878');
    leafGrad.appendChild(lg1); leafGrad.appendChild(lg2);
    defs.appendChild(leafGrad);

    var nFlowers = 7 + Math.floor(rand(0, 4));
    var delay = 0;

    for (var i = 0; i < nFlowers; i++) {
      var t = 0.1 + (i / (nFlowers - 1)) * 0.82 + rand(-0.02, 0.02);
      var pt = vine.getPointAtLength(pathLen * Math.min(Math.max(t, 0), 1));
      var isBud = i === 0 || i === nFlowers - 1 || Math.random() < 0.18;
      var scale = isBud ? rand(0.38, 0.5) : rand(0.72, 1.15);
      var palette = PETAL_SETS[Math.floor(rand(0, PETAL_SETS.length))];

      if (i % 2 === 0) {
        var leafWrap = document.createElementNS(svgNS, 'g');
        leafWrap.setAttribute('transform', 'translate(' + pt.x.toFixed(1) + ',' + (pt.y + 4).toFixed(1) + ') rotate(' + rand(-50, 50).toFixed(1) + ')');
        var lw = 15 * scale, lh = 7 * scale;
        var leaf = document.createElementNS(svgNS, 'path');
        leaf.setAttribute('d', 'M0 0 Q ' + (lw * 0.5) + ' ' + (-lh) + ' ' + lw + ' 0 Q ' + (lw * 0.5) + ' ' + lh + ' 0 0 Z');
        leaf.setAttribute('fill', 'url(#' + leafGradId + ')');
        leaf.setAttribute('class', 'qs-leaf');
        leaf.style.setProperty('--qs-delay', delay.toFixed(2) + 's');
        leafWrap.appendChild(leaf);
        flowerGroup.appendChild(leafWrap);
        delay += 0.05;
      }

      var fg = document.createElementNS(svgNS, 'g');
      fg.setAttribute('transform', 'translate(' + pt.x.toFixed(1) + ',' + pt.y.toFixed(1) + ')');

      var nPetals = isBud ? 3 : 5 + Math.floor(rand(0, 2));
      var petalW = 15 * scale, petalH = 22 * scale;

      var gradId = uid();
      var rg = document.createElementNS(svgNS, 'radialGradient');
      rg.setAttribute('id', gradId);
      rg.setAttribute('cx', '35%'); rg.setAttribute('cy', '25%'); rg.setAttribute('r', '75%');
      var stop1 = document.createElementNS(svgNS, 'stop'); stop1.setAttribute('offset', '0%'); stop1.setAttribute('stop-color', palette[2]);
      var stop2 = document.createElementNS(svgNS, 'stop'); stop2.setAttribute('offset', '55%'); stop2.setAttribute('stop-color', palette[0]);
      var stop3 = document.createElementNS(svgNS, 'stop'); stop3.setAttribute('offset', '100%'); stop3.setAttribute('stop-color', palette[1]);
      rg.appendChild(stop1); rg.appendChild(stop2); rg.appendChild(stop3);
      defs.appendChild(rg);

      for (var p = 0; p < nPetals; p++) {
        var pWrap = document.createElementNS(svgNS, 'g');
        pWrap.setAttribute('transform', 'rotate(' + (p * (360 / nPetals) + rand(-10, 10)).toFixed(1) + ')');
        var petal = document.createElementNS(svgNS, 'path');
        petal.setAttribute('d', 'M0 0 C ' + (petalW * 0.9) + ' ' + (petalH * 0.15) + ' ' + (petalW * 0.75) + ' ' + (petalH * 0.85) + ' 0 ' + petalH + ' C ' + (-petalW * 0.75) + ' ' + (petalH * 0.85) + ' ' + (-petalW * 0.9) + ' ' + (petalH * 0.15) + ' 0 0 Z');
        petal.setAttribute('fill', 'url(#' + gradId + ')');
        petal.setAttribute('class', 'qs-petal');
        petal.style.setProperty('--qs-delay', delay.toFixed(2) + 's');
        pWrap.appendChild(petal);
        fg.appendChild(pWrap);
        delay += 0.045;
      }

      if (!isBud) {
        var center = document.createElementNS(svgNS, 'circle');
        center.setAttribute('cx', 0); center.setAttribute('cy', 0);
        center.setAttribute('r', (3.2 * scale).toFixed(2));
        center.setAttribute('class', 'qs-flower-center');
        center.style.setProperty('--qs-delay', (delay + 0.25).toFixed(2) + 's');
        fg.appendChild(center);
      }

      flowerGroup.appendChild(fg);
    }

    el.appendChild(svg);
  }

  function initBlooms(root) {
    (root || document).querySelectorAll('[data-qs-bloom]').forEach(function (el) {
      if (!el.dataset.built) { buildCluster(el); el.dataset.built = '1'; }
    });
  }

  function watchBlooms() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-qs-bloom]').forEach(function (el) { el.classList.add('qs-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('qs-in'); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('[data-qs-bloom]').forEach(function (el) { io.observe(el); });

    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-qs-bloom]');
      if (c) {
        c.classList.remove('qs-in');
        void c.offsetWidth;
        setTimeout(function () { c.classList.add('qs-in'); }, 40);
      }
    });
  }

  function init() {
    initBlooms(document);
    watchBlooms();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    initBlooms(e.target);
    document.querySelectorAll('[data-qs-bloom]').forEach(function (el) { el.classList.add('qs-in'); });
  });

  /* ---------------- Variant picker (Qissaat Product Hero) ---------------- */
  function initVariantPickers(root) {
    (root || document).querySelectorAll('[data-qs-variant-form]').forEach(function (formEl) {
      if (formEl.dataset.qsInit) return;
      formEl.dataset.qsInit = '1';
      var variantsNode = formEl.querySelector('[data-qs-variants]');
      var submitBtn = formEl.querySelector('[data-qs-submit]');
      var variants;
      try {
        variants = JSON.parse(variantsNode.textContent);
        if (!variants || !variants.length) throw new Error('empty variant list');
      } catch (e) {
        /* Fail loudly instead of silently selling the default variant. */
        console.error('[Qissaat] variant data failed to parse — add to cart disabled', e);
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'temporarily unavailable';
        }
        return;
      }
      var optionInputs = formEl.querySelectorAll('[data-qs-option]');
      var hiddenId = formEl.querySelector('[data-qs-variant-id]');
      var priceEl = formEl.querySelector('[data-qs-price]');
      var mainImg = document.querySelector('[data-qs-main-image]');

      function currentSelection() {
        var sel = [];
        optionInputs.forEach(function (group) {
          var checked = group.querySelector('input:checked, option:checked');
          sel.push(checked ? checked.value : null);
        });
        return sel;
      }
      function findVariant(sel) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < sel.length; j++) {
            if (sel[j] !== null && v.options[j] !== sel[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }
      function update() {
        var v = findVariant(currentSelection());
        if (!v) {
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = submitBtn.dataset.soldLabel;
          }
          return;
        }
        hiddenId.value = v.id;
        if (priceEl) priceEl.textContent = v.priceFormatted;
        if (submitBtn) {
          submitBtn.disabled = !v.available;
          submitBtn.textContent = v.available ? submitBtn.dataset.addLabel : submitBtn.dataset.soldLabel;
        }
        if (mainImg && v.image) mainImg.src = v.image;
      }
      optionInputs.forEach(function (group) {
        group.addEventListener('change', update);
      });
      /* Last line of defence: re-resolve the variant at submit time so a wrong
         or stale hidden id can never reach the cart. */
      formEl.addEventListener('submit', function (e) {
        var v = findVariant(currentSelection());
        if (!v || !v.available) { e.preventDefault(); update(); return; }
        hiddenId.value = v.id;
      });
      update();
    });
  }
  window.qsInitVariantPickers = initVariantPickers;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initVariantPickers(document); });
  else initVariantPickers(document);
  document.addEventListener('shopify:section:load', function (e) { initVariantPickers(e.target); });
})();
